
export function toggleOneMany(value, one, twoThreeFour, more){
    const mod100 = value % 100;
    if (10 < mod100 && mod100 < 20) return more;
    switch (value % 10){
        case 1: return one;
        case 2: case 3: case 4: return twoThreeFour;
        default: return more;
    }
}